import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import EdgesPage from '../../routes/admin/EdgesPage';

export default function InstallerDialog(props) {
    const { open, onClose } = props;

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <EdgesPage distributorShowInstallerEdges={true} installer={props.installer} label={props.installer.name}/>
        </Dialog>)
}